module.exports = __webpack_public_path__ + "static/media/providerSilverTop3M.933de27c.webp";